import React from 'react';
import Styled from '../styles/FVActionsButton.styled';
import Colors from 'enums/Colors';
import { MdDelete, MdEditSquare } from 'react-icons/md';
import { Popconfirm } from 'antd';


interface FVActionsButtonProps {
    onEdit: () => void;
    onDelete: () => void;
    msgDelete?: string;
}


const FVActionButtons: React.FC<FVActionsButtonProps> = ({ onEdit, onDelete, msgDelete }) => {
    return (
        <Styled.Container>
            <Styled.Button background={Colors.Yellow} color={Colors.Blue} onClick={onEdit}>
                <MdEditSquare />
            </Styled.Button>
            <Popconfirm
                title="Realmente deseja deletar?"
                description={msgDelete}
                onConfirm={onDelete}
                okText="Sim"
                cancelText="Não"
            >
                <Styled.Button background={Colors.Red}>
                    <MdDelete />
                </Styled.Button>
            </Popconfirm>
        </Styled.Container>
    );
};

export default FVActionButtons;
